import React from 'react';
// import { useProjectStore } from '../../stores/projectStore';

const TableauDeBord: React.FC = () => {
//   const { projects, fetchProjects } = useProjectStore();

//   useEffect(()=> {
    
//     fetchProjects()
//   })

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">Tableau de bord</h1>
      {/* <ul>
        {projects.map((project) => (
          <li key={project.id} className="p-2 border-b">
            {project.title}
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default TableauDeBord;
